export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.6-1817.13",
  commitId: "297a366c5706a5861f6de7aa20bb9342d671ba61",
  commitTime: "2026-07-06T18:17:13.000Z",
});
